import { ref, watch, computed } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import router from '@/router/index'

// Notification

export default function useCodeList() {
  // Use toast
  const toast = useToast()
  const route = router.history.current

  const refCodesTable = ref(null)

  // Table Handlers
  const tableColumns = [
    {
      key: 'sclcID',
      label: 'id',
      sortable: true,
    },
    {
      key: 'code',
      label: 'Product code',
      sortable: true,
    },
    {
      key: 'name',
      label: 'Product description',
      sortable: true,
    },
    {
      key: 'category',
      label: 'Product Category',
      sortable: false,
    },
    {
      key: 'lotBased',
      label: 'Lot-based',
      sortable: true,
    },
    {
      key: 'fileSequence',
      label: 'File Sequence prefix',
      sortable: true,
    },
    {
      key: 'cnDiscountCode',
      label: 'CN Discount code',
      sortable: true,
    },
    { key: 'actions' },
  ]
  const perPage = ref(route.query.perPage ?? process.env.VUE_APP_PER_PAGE_CONTENT)
  const totalCodes = ref(0)
  const currentPage = ref(route.query.page ?? 1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref(route.query.search ?? '')
  const sortBy = ref(route.query.sortBy ?? 'sclcID')
  const isSortDirDesc = ref(route.query.sortDesc ? (route.query.sortDesc !== 'false') : false)
  const createdAtFilter = ref(route.query.createdAt || '')
  const lotBasedFilter = ref(route.query.lotBased || '')
  const categoryFilter = ref([])
  if (Array.isArray(route.query.category)) {
    categoryFilter.value = route.query.category
  } else if (route.query.category) {
    categoryFilter.value = [route.query.category]
  }
  const toDeletedID = ref(null)
  const currentDataLength = ref(0)
  const itemListData = ref([])
  let initialLoad = true

  const dataMeta = computed(() => {
    const localItemsCount = refCodesTable.value ? refCodesTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalCodes.value,
    }
  })

  const refetchData = () => {
    refCodesTable.value.refresh()
  }

  // watch([searchQuery, idSearchQuery, categoryFilter, createdAtFilter], () => {
  //   currentPage.value = 1
  //   refetchData()
  // }, { deep: true })

  // watch([currentPage], () => {
  //   refetchData()
  // }, { deep: true })

  const fetchCodes = () => {
    store
      .dispatch('app-product-code/fetchCodes', {
        search: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        categories: categoryFilter.value,
        createdAt: createdAtFilter.value,
        lotBased: lotBasedFilter.value,
      },
      { root: true })
      .then(response => {
        const { codes, total } = response.data
        itemListData.value = codes
        currentDataLength.value = codes.length
        // callback(codes)
        totalCodes.value = total
        if (!initialLoad) {
          router.replace({
            query: {
              search: searchQuery.value,
              perPage: perPage.value,
              page: currentPage.value,
              sortBy: sortBy.value,
              sortDesc: isSortDirDesc.value,
              category: categoryFilter.value,
              createdAt: createdAtFilter.value,
              lotBased: lotBasedFilter.value,
            },
          }).catch(() => {})
        }
        initialLoad = false
      })
      .catch(error => {
        toast({
          component: ToastificationContent,
          props: {
            title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  let timer = null
  watch([categoryFilter, createdAtFilter, lotBasedFilter], () => {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      currentPage.value = 1
      fetchCodes()
    }, 1000)
  }, { deep: true })

  watch([searchQuery], (current, prev) => {
    const currentVal = current[0]
    const prevVal = prev[0]
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      if ((!currentVal && prevVal) || (currentVal && currentVal.length > 2)) {
        currentPage.value = 1
        fetchCodes()
      }
    }, 1000)
  }, { deep: true })

  watch([sortBy, perPage, isSortDirDesc, currentPage], () => {
    fetchCodes()
  }, { deep: true })

  fetchCodes()

  const deleteCode = () => {
    store
      .dispatch('app-product-code/deleteCode', {
        id: toDeletedID.value,
      },
      { root: true })
      .then(response => {
        fetchCodes()
        toast({
          component: ToastificationContent,
          props: {
            title: response.data.message ?? '',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
      .catch(error => {
        toast({
          component: ToastificationContent,
          props: {
            title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  return {
    fetchCodes,
    tableColumns,
    perPage,
    currentPage,
    totalCodes,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refCodesTable,

    refetchData,

    toDeletedID,
    deleteCode,
    currentDataLength,
    itemListData,

    // Extra Filters
    categoryFilter,
    createdAtFilter,
    lotBasedFilter,
  }
}
